<template>
    <div class="modal fade show d-block" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ $t('runDataBatch') }}</h5>
                    <button type="button" class="btn-close" @click="$emit('close')" :disabled="running"></button>
                </div>
                <div class="modal-body">
                    <div v-if="!running && !result">
                        <p>{{ $t('areYouSureYouWantToRunThisDataBatch') }}</p>
                        <p class="fw-bold">{{ batch.name }}</p>
                    </div>
                    <div v-if="running" class="text-center py-3">
                        <div class="spinner-border text-primary mb-2" role="status"></div>
                        <div class="text-muted">{{ $t('running') }}...</div>
                    </div>
                    <div v-if="result" class="text-center py-3">
                        <i :class="result === 'success' ? 'fas fa-check-circle text-success' : 'fas fa-times-circle text-danger'" style="font-size: 32px"></i>
                        <div class="mt-2">{{ resultMessage }}</div>
                    </div>
                </div>
                <div class="modal-footer">
                    <div v-if="!running && !result" class="form-check me-auto">
                        <input class="form-check-input" type="checkbox" id="flexCheckDefault" v-model="recreateTable">
                        <label class="form-check-label" for="flexCheckDefault">
                            {{ $t('recreateTable') }}
                        </label>
                    </div>
                    <button v-if="result" type="button" class="btn btn-secondary" @click="$emit('close')">
                        {{ $t('close') }}
                    </button>
                    <template v-if="!running && !result">
                        <button type="button" class="btn btn-secondary" @click="$emit('close')">
                            {{ $t('cancel') }}
                        </button>
                        <button type="button" class="btn btn-primary" @click="run">
                            <i class="fas fa-play"></i> {{ $t('confirm') }}
                        </button>
                    </template>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-backdrop fade show"></div>
</template>

<script>
import DataBatchApi from '../../api/server/databatch';

export default {
    name: 'DataBatchRunModal',
    props: {
        batch: { type: Object, required: true }
    },
    data() {
        return {
            running: false,
            result: null,
            resultMessage: '',
            recreateTable: this.batch.recreateTable || false
        };
    },
    computed: {
        dataSpaceId() {
            return this.$route.params.id;
        }
    },
    methods: {
        async run() {
            this.running = true;
            this.result = null;
            try {
                await DataBatchApi.dataBatchRun(this.dataSpaceId, this.batch.id, this.recreateTable);
                this.result = 'success';
                this.resultMessage = this.$t('batchRunSuccessful');
            } catch (error) {
                this.result = 'error';
                var key = error?.response?.body?.message || 'unknownError';
                this.resultMessage = this.$t(key);
            } finally {
                this.running = false;
                this.$emit('reload');
            }
        }
    }
};
</script>